import store from "@/store";
import originalPermissionsHelper from "@/helpers/permissions";
import {Permission, PermissionRestriction, PermissionServiceInterface} from '@/global/types/permission';
import {RouteLocationAsRelative} from 'vue-router';

const service: PermissionServiceInterface = {
    getRouteByPermissionFail: (
        permission: Permission,
        restriction: null | PermissionRestriction = null,
        query: RouteLocationAsRelative['query'] = {}
    ): RouteLocationAsRelative => {

        const permissions = permission
            ? [permission].concat(store.getters["user/permissions/permissions"])
            : store.getters["user/permissions/permissions"];

        // Check restrictions through each user allowed permission
        for (let i: number = 0; i < permissions.length; i++) {

            if (restriction || store.getters["user/permissions/hasRestriction"](permissions[i])) {

                restriction = restriction ?? store.getters['user/permissions/getRestriction'](permissions[i]) as PermissionRestriction;

                if (restriction.isUserCoreIdEmpty) {

                    return {name: "errors.403", params: {error: "empty-core-id"}, query};
                }

                if (restriction.isUserVirtualDenied) {

                    return {name: "errors.403", params: {error: "virtual-denied"}, query};
                }

                if (restriction.isUserDisabled) {

                    return {name: "errors.403", params: {error: "disabled"}, query};
                }

                if (false === restriction.isUserActive) {

                    return {name: "errors.403", params: {error: "not-active"}, query};
                }

                if (false === restriction.isUserTypeAccessAllowed) {

                    return {name: "errors.403", params: {error: "not-allowed"}, query};
                }

                if (false === restriction.isUserManagerDefined) {

                    return {name: "errors.403", params: {error: "no-manager"}, query};
                }

                if (restriction.isUserManagerSelf) {

                    return {name: "errors.403", params: {error: "self-manager"}, query};
                }

                if (false === restriction.isUserLocationDefined) {

                    return {name: "errors.403", params: {error: "no-location"}, query};
                }

                if ((false === restriction.isUserInSupportedCountry) || (false === restriction.isUserAllowed)) {

                    return {name: "errors.403", params: {error: "eligibility-location"}, query};
                }

                if (restriction.isUserSecondayAccount) {

                    return {name: "errors.403", params: {error: "secondary-account"}, query};
                }
            }
        }

        return originalPermissionsHelper.getRouteByPermissionFail(permission, restriction);
    },
    isRestricted(restriction: PermissionRestriction): boolean {

        // We need to check only for custom properties that differ from
        if (
            restriction.isUserCoreIdEmpty
            || restriction.isUserVirtualDenied
            || false === restriction.isUserManagerDefined
            || restriction.isUserManagerSelf
            || false === restriction.isUserLocationDefined
            || restriction.isUserSecondayAccount
        ) {

            return true;
        }

        return originalPermissionsHelper.isRestricted(restriction);
    }
}

export default service